import { useLayoutEffect } from 'react'
import { dismissHtmlBootSplash } from '../platform/ui/bootSplash'

type AppLoadingRowProps = {
  label?: string
}

/** Spinner + label row (sans-serif, slightly larger type). */
export function AppLoadingRow({ label = 'Loading…' }: AppLoadingRowProps) {
  return (
    <div className="app-loading-row" role="status" aria-live="polite">
      <span className="app-boot-spinner" aria-hidden />
      <span className="app-boot-label">{label}</span>
    </div>
  )
}

type AppBootLoadingProps = {
  label?: string
}

/** Full-viewport centered loading state (auth boot, post-login refresh). */
export function AppBootLoading({ label }: AppBootLoadingProps) {
  useLayoutEffect(() => {
    dismissHtmlBootSplash()
  }, [])

  return (
    <div className="app-boot">
      <AppLoadingRow label={label} />
    </div>
  )
}
